<template>
  <div style="min-width:1290px;">
    <MyBanner />
    <div>
      <div class="w1200">
        <div style="padding:20px 0;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>平台公告</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-box">
          <div class="header-top">
            <div class="header">信息类型：</div>
            <div class="header-type" v-for="item in information" :key="item.id" @click="activeMes(item.id,item.type)" :class="{'active':activeNum1==item.id}">{{item.title}}</div>
          </div>
          <div class="line"></div>
          <div class="header-top">
            <div class="header">排序方式：</div>
            <div class="header-type" v-for="item in Sort" :key="item.id" @click="activeMess(item.id,item.descs,item.ascs)" :class="{'active':activeNum2==item.id}">{{item.title}}
            </div>
          </div>
          <div class="line"></div>
          <div class="header-top">
            <div class="header">项目类别：</div>
            <div class="header-type" v-for="item in ProjectCategory" :key="item.id" @click="activeMessa(item.id,item.tradeClassification)" :class="{'active':activeNum3==item.id}">
              {{item.title}}</div>
            <div class="input-box">
              <el-input placeholder="请输入搜索关键字" size="default" :prefix-icon="Search" v-model="input" clearable></el-input>
              <el-button type="primary" size="default" style="margin-left: 10px;" @click="search">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="header-box">
          <div v-for="item in mesageArr" :key="item.id" @click="detail(item.id)" style="cursor: pointer;">
            <div class="announcement-than">
              <div class="announcement">
                <div class="announcement-tip">{{Type(item.type)}}</div>
                <div class="announcement-time">{{item.name}}</div>
              </div>
              <div class="Time" v-if="item.publishTime&&item.publishTime!=''">{{item.publishTime.slice(0,11)}}</div>
            </div>
            <div class="announcement-message">
              <div class="announcement-mymesage">公告详情：</div>
              <div class="announcement-mymesage-box Time">{{removeHtmlStyle(item.content)}}</div>
            </div>
            <div class="announcement-flex">
              <div class="flex">
                <div class="title-box">项目类别：</div>
                <div class="content-box">{{TypeX(item.tradeClassification)}}</div>
              </div>
              <!-- <div class="flex">
                <div class="title-box">报价截止时间：</div>
                <div class="content-box">{{item.endTime}}</div>
              </div> -->
              <div class="flex">
                <div class="title-box">发布时间：</div>
                <div class="content-box">{{item.publishTime}}</div>
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end;padding: 20px 10px 0px 20px;">
            <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :size="size" :disabled="disabled" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>
<script setup>
import { Search } from '@element-plus/icons-vue'
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter,useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import { getTableList } from '@/api/index.js'
let router = useRouter()
let route = useRoute()
let activeNum1 = ref(0);
let activeNum2 = ref(0);
let activeNum3 = ref(0);
let input = ref('')
let currentPage = ref(1)
let total = ref()
let current = ref(1)
let pageSize = ref(10)
let size = ref('default')
let disabled = ref(false)
let seaching = ref(false)
let mesageArr = ref()
let Stype = ref('tender_bulletin')
let Sdescs = ref('publish_time')
let Sascs = ref('')
let StradeClassification = ref('')
let information = ref([
  { id: 0, title: '招标公告', type: 'tender_bulletin' },
  { id: 1, title: '变更公告', type: 'correctional_bulletin' },
  { id: 2, title: '中标候选人公示', type: 'win_candidate_publicity' },
  { id: 3, title: '中标结果公告', type: 'win_notice' },
  { id: 4, title: '其他公告', type: 'failed_notice' }
])
let Sort = ref([
  { id: 0, title: '全部', descs: 'publish_time', ascs: '' },
  { id: 1, title: '发布时间降序', descs: 'publish_time', ascs: '' },
  { id: 2, title: '发布时间升序', descs: '', ascs: 'publish_time' },
  { id: 3, title: '截止时间降序', descs: 'end_time', ascs: '' },
  { id: 4, title: '截止时间升序', descs: '', ascs: 'end_time' }
])
let ProjectCategory = ref([
  { id: 0, title: '全部', tradeClassification: "" },
  { id: 1, title: '工程', tradeClassification: "A" },
  { id: 2, title: '货物', tradeClassification: "B" },
  { id: 3, title: '服务', tradeClassification: "C" }
])
let Type = (value) => {
  if (value == 'tender_bulletin') {
    return '招标公告'
  } else if (value == 'correctional_bulletin') {
    return '变更公告'
  } else if (value == 'win_candidate_publicity') {
    return '中标候选人公示'
  } else if (value == 'win_notice') {
    return '中标结果公告'
  } else if (value == 'failed_notice') {
    return '其他公告'
  }
}
let TypeX = (value) => {
  if (value == "A") {
    return '工程'
  } else if (value == "B") {
    return '货物'
  } else if (value == "C") {
    return '服务'
  }
}
let removeHtmlStyle = (html) => {
  const newHtml = html
    .replace(/<\s*script[^>]*>(.|[\r\n])*?<\s*\/script[^>]*>/gi, '')
    .replace(/<\s*style[^>]*>(.|[\r\n])*?<\s*\/style[^>]*>/gi, '')
    .replace(/<\/?[^>]+>/g, '')
    .replace(/&[a-z]+;/gi, '')
    .substring(0, 1000)
  return newHtml
}
let search = () => {
  current.value = 1
  seaching.value = true
  GetNewsTable()
}
let activeMes = (num, type) => {
  activeNum1.value = num
  current.value = 1
  Stype.value = type
  GetNewsTable()
}
let activeMess = (num, descs, ascs) => {
  activeNum2.value = num
  current.value = 1
  Sdescs.value = descs
  Sascs.value = ascs
  GetNewsTable()
}
let activeMessa = (num, tradeClassification) => {
  activeNum3.value = num
  current.value = 1
  StradeClassification.value = tradeClassification
  GetNewsTable()
}
// 每页
let handleSizeChange = (val) => {
  pageSize.value = val
  GetNewsTable()
}
// 当前页
let handleCurrentChange = (val) => {
  current.value = val
  GetNewsTable()
}
let detail = (id) => {
  router.push({ path: '/platformAnnouncementsDetail', query: { ids: id } })
}

let GetNewsTable = async () => {
  getTableList({ current: current.value, size: pageSize.value, type: Stype.value, descs: Sdescs.value, ascs: Sascs.value, tradeClassification: StradeClassification.value, name: input.value }).then(res => {
    mesageArr.value = res.data.records
    total.value = res.data.total
  })
    // 清除地址栏参数
    router.replace({ query: {} });
}
onMounted(async () => {
  if (router.currentRoute.value.query.value) {
    input.value = router.currentRoute.value.query.value
  }

  await GetNewsTable()
})
</script>
<style scoped>
.announcement-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
}
.flex {
  display: flex;
  align-items: center;
}
.title-box {
  font-size: 14px;
  font-weight: 400;
  color: rgb(0, 0, 0);
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: rgb(10, 96, 234);
}
.announcement-mymesage-box {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.announcement-mymesage {
  width: 80px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
}
.announcement-message {
  display: flex;
  padding-bottom: 20px;
}
.announcement-tip {
  font-size: 14px;
  font-weight: 500;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgba(10, 96, 234, 1);
  padding: 5px;
  margin-right: 15px;
}
.announcement-time {
  font-size: 18px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.Time {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.announcement-than {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.announcement {
  display: flex;
  align-items: center;
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.input-box {
  position: absolute;
  right: 0;
  top: 15px;
  display: flex;
}
.line {
  width: 100%;
  height: 1px;
  background: rgb(233, 237, 242);
}
.header-box {
  border-radius: 4px;
  background: rgb(255, 255, 255);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 22px 30px;
  margin-bottom: 30px;
}
.header-top {
  display: flex;
  align-items: center;
  padding: 15px 0;
  position: relative;
}
.header-top:nth-child(1) {
  padding: 0 0 11px 0;
}
.header-top:nth-last-child(1) {
  padding: 15px 0 0px 0;
}
.header {
  font-size: 14px;
  font-weight: 700;
  line-height: 30px;
  color: rgb(51, 51, 51);
  text-align: left;
}
.header-type {
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
  color: rgb(51, 51, 51);
  text-align: left;
  margin-left: 30px;
  cursor: pointer;
}
.active {
  color: rgba(0, 117, 194, 1);
}
</style>